import { defineRoutes } from "@/service/routing/schema";

const base = "/sklep";

export const shopRoutes = defineRoutes({
  "shop.index": () => `${base}`,
  "shop.wesub_product.show": ({ id }: { id: string }) => `${base}/wesub/${id}`,
} as const);
